/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateEmailMarkAsRead } from '../../axios/candidateEmailMarkAsRead'
import type {
	CandidateEmailMarkAsReadError,
	CandidateEmailMarkAsReadPathParams,
	CandidateEmailMarkAsReadRequest,
	CandidateEmailMarkAsReadResponse,
} from '../../types/CandidateEmailMarkAsRead'

export const candidateEmailMarkAsReadMutationKey = () => [{ url: '/candidates/:candidateId/emails/read' }] as const

export type CandidateEmailMarkAsReadMutationKey = ReturnType<typeof candidateEmailMarkAsReadMutationKey>

export type CandidateEmailMarkAsReadVariables = {
	candidateId: CandidateEmailMarkAsReadPathParams['candidateId']
	data: CandidateEmailMarkAsReadRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEmailController.php CandidateEmailController::markAsRead */
export function useCandidateEmailMarkAsRead<TContext = unknown>(
	options?: UseMutationOptions<
		CandidateEmailMarkAsReadResponse,
		AxiosError<CandidateEmailMarkAsReadError>,
		CandidateEmailMarkAsReadVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateEmailMarkAsReadMutationKey(),
		mutationFn: ({ candidateId, data }: CandidateEmailMarkAsReadVariables) =>
			candidateEmailMarkAsRead(candidateId, data, config).then(res => res.data),
		...options,
	})
}
